import { Reveal, SectionHead } from "@/components/Reveal";
import { TempGauge } from "@/components/TempGauge";

const STEPS = [
  {
    title: "Normale situatie",
    text: "Oppervlaktetemperaturen binnen de ingestelde zones blijven onder de grenswaarden.",
    visual: (
      <div className="relative h-28 overflow-hidden rounded-xl bg-[#10232F]">
        <div className="absolute inset-0 opacity-40" style={{ backgroundImage: "radial-gradient(circle at 50% 60%, rgba(43,159,215,0.5), transparent 65%)" }} />
        <div className="scan-line" />
      </div>
    ),
  },
  {
    title: "Afwijkende warmteontwikkeling",
    text: "Een oplopende oppervlaktetemperatuur wordt zichtbaar binnen de detectiezone.",
    visual: (
      <div className="relative h-28 overflow-hidden rounded-xl bg-[#10232F]">
        <div className="absolute inset-0 opacity-70" style={{ backgroundImage: "radial-gradient(circle at 55% 60%, rgba(255,138,0,0.75), rgba(255,138,0,0.15) 45%, transparent 70%)" }} />
        <span className="hotspot-ring absolute left-[50%] top-[50%] h-10 w-10 -translate-x-1/2 -translate-y-1/2 rounded-full border border-[#FF8A00]/70" />
      </div>
    ),
  },
  {
    title: "Vooralarm of alarm",
    text: "Bij overschrijding van een grenswaarde kan het systeem automatisch een melding of alarm activeren.",
    visual: (
      <div className="relative flex h-28 items-center justify-center overflow-hidden rounded-xl bg-[#10232F]">
        <div className="alarm-zone absolute inset-0 bg-[#E5483F]/20" />
        <span className="rounded-full border border-[#E5483F]/70 bg-[#090D10]/80 px-4 py-1.5 font-heading text-xs font-bold uppercase tracking-[0.2em] text-[#E5483F]">
          Alarm actief
        </span>
      </div>
    ),
  },
];

export const Problem = () => (
  <section className="relative py-24 md:py-36" data-testid="problem-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
      <SectionHead nr="01" overline="Het risico" title="Een beginnende hotspot is niet altijd zichtbaar" />
      <div className="mt-10 grid gap-12 lg:grid-cols-[1.2fr_0.8fr] lg:gap-20">
        <Reveal delay={0.1}>
          <p className="max-w-2xl text-base leading-relaxed text-[#CBD3D9]">
            Binnen recyclingbedrijven kunnen warmteontwikkelingen ontstaan tussen opgeslagen
            materialen, bij machines, transportbanden, accu's, afvalstromen en andere risicobronnen.
            Een normale beveiligingscamera laat vooral zien wat voor het menselijk oog zichtbaar is.
            Een thermische camera analyseert juist temperatuurverschillen en warmtepatronen.
          </p>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-[#CBD3D9]">
            Hierdoor kan een ongebruikelijke temperatuurstijging eerder worden gesignaleerd, nog
            voordat medewerkers rook of vlammen waarnemen.
          </p>
        </Reveal>
        <Reveal delay={0.2} className="lg:justify-self-end">
          <TempGauge />
        </Reveal>
      </div>

      <div className="mt-16 grid gap-6 md:grid-cols-3">
        {STEPS.map((step, i) => (
          <Reveal key={step.title} delay={i * 0.12}>
            <div className="group h-full rounded-2xl border border-white/10 bg-[#0c1319] p-6 transition-[border-color] duration-500 hover:border-[#2B9FD7]/40">
              {step.visual}
              <p className="mt-5 flex items-center gap-3 font-heading text-base font-bold text-[#F5F7F9]">
                <span className="text-xs text-[#FF8A00]">0{i + 1}</span> {step.title}
              </p>
              <p className="mt-2 text-sm leading-relaxed text-[#CBD3D9]/80">{step.text}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <p className="mt-10 max-w-3xl border-l-2 border-[#2B9FD7]/50 pl-5 text-sm leading-relaxed text-[#CBD3D9]/70">
          De exacte detectiemogelijkheden zijn afhankelijk van het gekozen cameramodel, de afstand,
          zichtlijn, materiaalsoort, montagepositie en configuratie.
        </p>
      </Reveal>
    </div>
  </section>
);
